/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { OfficeRoleRestService } from '@gh/builder-shared-data';
import { EntityInputDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { OfficeRole } from './office-role.model';
import { map$ } from '@gh/rx/operators';

@Injectable()
export class OfficeRoleListBusinessService implements InitViewService, InitDialogViewService<EntityInputDialogConfig<OfficeRole>> {

  constructor(private officeRoleRest: OfficeRoleRestService) {

  }

  initView(route?: ActivatedRouteSnapshot): any {
    return {
      officeRoles: this.officeRoleRest.findAll(),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<OfficeRole>>): any {
    return route.input.id ? this.get(route.input.id) : this.prepareForCreate();
  }

  prepareForCreate(): OfficeRole {
    return {
      id: '',
      name: '',
      active: true,
    };
  }

  create(role: OfficeRole): Observable<OfficeRole> {
    return this.officeRoleRest.create(role);
  }

  update(role: OfficeRole): Observable<OfficeRole> {
    return this.officeRoleRest.update(role);
  }

  get(id: ID): Observable<OfficeRole> {
    return this.officeRoleRest.get(id);
  }

  findAll(showDeleted?: boolean): Observable<OfficeRole[]> {
    return this.officeRoleRest.findAll(showDeleted);
  }

  checkUsage(role: OfficeRole): Observable<boolean> {
    return this.officeRoleRest.checkUsage(role).pipe(map$((res) => !!res.used));
  }

  delete(role: OfficeRole): Observable<void> {
    return this.officeRoleRest.delete(role.id);
  }

  undelete(role: OfficeRole): Observable<void> {
    return this.officeRoleRest.undelete(role.id);
  }

}
